import React from 'react';
import Container from '../layout/Container';
import Eyebrow from '../ui/Eyebrow';
import SectionHeading from '../ui/SectionHeading';
import { colors, font } from '../../lib/tokens';

const ITEMS: { k: string; v: React.ReactNode }[] = [
  { k: 'On-premise',            v: 'Runs inside your hospital network. No PHI leaves your environment.' },
  { k: 'Full audit trail',      v: 'Every suggestion and confirmation is logged with clinician, timestamp, and model version.' },
  { k: 'Clinician-in-the-loop', v: 'KatlaCode never codes autonomously. Every code is confirmed by a licensed clinician.' },
  { k: 'Locked models',         v: <>Deployed model versions are pinned. Nothing changes without clinical <span style={{ whiteSpace: 'nowrap' }}>sign-off</span>.</> },
];

const BADGES = ['GDPR'];

export default function SecuritySection() {
  return (
    <section id="security" className="kc-section" style={{ background: colors.ink, color: '#FFF' }}>
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-[0.9fr_1.3fr] gap-12 md:gap-24">
          <div data-reveal>
            <Eyebrow color="#93C5FD">Security &amp; compliance</Eyebrow>
            <SectionHeading style={{ marginBottom: 24 }}>
              Hospital-grade
              {' '}<br />
              from day one.
            </SectionHeading>
            <p style={{ color: '#94A3B8', fontSize: 16, lineHeight: 1.65, maxWidth: 360 }}>
              KatlaCode is already operating inside Iceland’s largest university hospital. We built
              it to meet that bar, not to retrofit it later.
            </p>
            <div style={{ display: 'flex', gap: 8, marginTop: 28, flexWrap: 'wrap' }}>
              {BADGES.map((b) => (
                <span
                  key={b}
                  style={{
                    padding: '6px 10px',
                    borderRadius: 999,
                    fontSize: 11,
                    fontFamily: font.mono,
                    color: '#93C5FD',
                    border: '1px solid rgba(147,197,253,0.3)',
                  }}
                >
                  {b}
                </span>
              ))}
            </div>
          </div>
          <div
            data-reveal
            className="kc-security-grid"
            style={{
              '--d': '80ms',
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.08)',
            } as React.CSSProperties}
          >
            {ITEMS.map((it, i) => (
              <div
                key={it.k}
                className="kc-security-cell"
                style={{ background: colors.ink }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    aria-hidden
                    className="kc-draw"
                    style={{ '--kc-draw-d': `${350 + i * 140}ms` } as React.CSSProperties}
                  >
                    <path
                      pathLength={1}
                      d="M2 7l3.5 3.5L12 3"
                      stroke="#93C5FD"
                      strokeWidth="1.6"
                      fill="none"
                      strokeLinecap="round"
                    />
                  </svg>
                  <span style={{ fontWeight: 500, fontSize: 15 }}>{it.k}</span>
                </div>
                <p style={{ color: '#94A3B8', fontSize: 13.5, lineHeight: 1.6, margin: 0 }}>
                  {it.v}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
